export default __webpack_public_path__ + "img/e50625c9e11a66bae1cd0222807d032d.png";